import {CHANGE_PLAN} from "../types";

export function changePlan(payload) {
   return { type: CHANGE_PLAN, payload }
}